var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"badge-container cursor-pointer"},[_c('v-icon',{staticClass:"pa-0 ma-0",attrs:{"color":"blue lighten-1","size":_vm.iconSize}},[_vm._v("mdi-creation-outline")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }